'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ../~/_dom-scroll-into-view@1.2.1@dom-scroll-into-view/lib/index.js
// module id = 129
// module chunks = 0